module.exports = __webpack_public_path__ + "media/images/american-express-68351fbf1fcd73f65073428abbc44a60.svg";